import { render, staticRenderFns } from "./PageSix.vue?vue&type=template&id=5ecb262e&scoped=true"
import script from "./PageSix.vue?vue&type=script&lang=js"
export * from "./PageSix.vue?vue&type=script&lang=js"
import style0 from "./PageSix.vue?vue&type=style&index=0&id=5ecb262e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecb262e",
  null
  
)

export default component.exports